<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>Change FTP password</template>
    <template v-slot:body>
      <v-form>
        <v-row>
          <v-col cols="12" class="pt-4">
            <p class="mb-0">
              Change account <strong>{{ account.user }}</strong> password.
            </p>
          </v-col>
          <v-col cols="12">
            <compact-password outlined
                              autocomplete="new-password"
                              label="Password"
                              v-validate="'required|min:8'"
                              data-vv-name="password"
                              data-vv-as="Password"
                              :error-messages="errors.collect('password')"
                              with-generator
                              v-model="password"></compact-password>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn :loading="loading" @click="changePassword">Change Password</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'ChangePasswordModal',
  mixins: [modalMixin],
  components: {
    CompactPassword,
  },
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      password: '',
      loading: false,
    }
  },
  computed: {},
  methods: {
    ...mapActions({
      setFtpAccountPassword: 'ftp/setFtpAccountPassword',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    async changePassword () {
      const valid = this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      try {
        await this.setFtpAccountPassword({
          ...this.account,
          pass: this.password,
          _username: this.$route.query.user,
        })
        this.reportSuccess(`Account password updated.`)
        this.$emit('password-updated')
        this.close()
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
    },
  },
}
</script>
